<template>
  <div class="fantan-mainbet">
    <div
      :class="[
        'invi-popper',
        this.tri1Toggle ||
        this.tri2Toggle ||
        this.tri3Toggle ||
        this.tri4Toggle ||
        this.tri5Toggle ||
        this.tri6Toggle
          ? 'show'
          : '',
      ]"
    >
      <div class="tri-top-ph">
        <fantan-bet-lot
          class="fantan-fan-betlot"
          :key="o1"
          :tri-toggle="tri1Toggle"
          :type="gameRow_fan[2]"
          :odd="odd(o1)"
          :category="o1"
          :gameType="game"
          :win="win_main === gameRow_fan[2]"
          :game="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow_fan[2])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>

      <div class="tri-bottom-ph">
        <fantan-bet-lot
          class="fantan-fan3-betlot"
          :key="o1"
          :tri-toggle="tri3Toggle"
          :type="gameRow_fan[0]"
          :odd="odd(o1)"
          :category="o1"
          :win="win_main === gameRow_fan[0]"
          :gameType="game"
          :game="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow_fan[0])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>

      <div class="tri-left-ph">
        <fantan-bet-lot
          class="fantan-fan4-betlot"
          :key="o1"
          :tri-toggle="tri4Toggle"
          :type="gameRow_fan[3]"
          :odd="odd(o1)"
          :category="o1"
          :win="win_main === gameRow_fan[3]"
          :gameType="game"
          :game="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow_fan[3])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>

      <div class="tri-right-ph">
        <fantan-bet-lot
          class="fantan-fan2-betlot"
          :key="o1"
          :tri-toggle="tri2Toggle"
          :type="gameRow_fan[1]"
          :odd="odd(o1)"
          :category="o1"
          :win="win_main === gameRow_fan[1]"
          :gameType="game"
          :game="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow_fan[1])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>

      <div class="middle-ph">
        <div class="square-o">
          <fantan-bet-lot
            class="fantan-odd-betlot"
            :key="o6"
            :tri-toggle="tri5Toggle"
            :type="gameRow_oe[0]"
            :odd="odd(o6)"
            :category="o6"
            :win="win_oe === gameRow_oe[0]"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(gameRow_oe[0])"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
        <div class="square-e">
          <fantan-bet-lot
            class="fantan-even-betlot"
            :key="o6"
            :tri-toggle="tri6Toggle"
            :type="gameRow_oe[1]"
            :odd="odd(o6)"
            :category="o6"
            :win="win_oe === gameRow_oe[1]"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(gameRow_oe[1])"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
      </div>
    </div>
    <div ref="triangle-area" class="triangle-area">
      <div ref="tri-top" class="tri-top">
        <div class="canvas-wrapper-top">
          <canvas
            ref="canvas-area-top"
            class="canvas-area-top"
            @click="triangle1Click()"
          ></canvas>
        </div>

        <div class="fantan-bet-lot-cell">
          <div class="fantan-bet-lot-title">
            <span>{{ $t("fantan.fan") }}</span>
            <span class="g-title">{{ $t("fantan.fan3").charAt(3) }}</span>
          </div>

          <div class="fantan-bet-lot-bet-no" justify="center">
            {{ odd(o1) }}
          </div>
          <div
            v-if="stakeRecordSum(gameRow_fan[2]) != 0"
            class="fantan-bet-lot-stake-total"
          >
            {{ fan3Stake }}
          </div>
        </div>
      </div>

      <div ref="tri-bottom" class="tri-bottom">
        <div class="canvas-wrapper-bottom">
          <canvas
            ref="canvas-area-buttom"
            class="canvas-area-buttom"
            @click="triangle3Click()"
          ></canvas>
        </div>

        <div class="fantan-bet-lot-cell">
          <div class="fantan-bet-lot-title">
            <span>{{ $t("fantan.fan") }}</span>
            <span class="g-title">{{ $t("fantan.fan1").charAt(3) }}</span>
          </div>

          <div class="fantan-bet-lot-bet-no" justify="center">
            {{ odd(o1) }}
          </div>
          <div
            v-if="stakeRecordSum(gameRow_fan[0]) != 0"
            class="fantan-bet-lot-stake-total"
          >
            {{ fan1Stake }}
          </div>
        </div>
      </div>

      <div ref="tri-left" class="tri-left">
        <div class="canvas-wrapper-left">
          <canvas ref="canvas-area-left" class="canvas-area-left"></canvas>
        </div>

        <div class="fantan-bet-lot-cell">
          <div class="fantan-bet-lot-title">
            <span>{{ $t("fantan.fan") }}</span>
            <span class="g-title">{{ $t("fantan.fan4").charAt(3) }}</span>
          </div>
          <div class="fantan-bet-lot-bet-no" justify="center">
            {{ odd(o1) }}
          </div>
          <div
            v-if="stakeRecordSum(gameRow_fan[3]) != 0"
            class="fantan-bet-lot-stake-total"
          >
            {{ fan4Stake }}
          </div>
        </div>
      </div>

      <div ref="tri-right" class="tri-right">
        <div class="canvas-wrapper-right">
          <canvas ref="canvas-area-right" class="canvas-area-right"></canvas>
        </div>

        <div class="fantan-bet-lot-cell">
          <div class="fantan-bet-lot-title">
            <span>{{ $t("fantan.fan") }}</span>
            <span class="g-title">{{ $t("fantan.fan2").charAt(3) }}</span>
          </div>

          <div class="fantan-bet-lot-bet-no" justify="center">
            {{ odd(o1) }}
          </div>
          <div
            v-if="stakeRecordSum(gameRow_fan[1]) != 0"
            class="fantan-bet-lot-stake-total"
          >
            {{ fan2Stake }}
          </div>
        </div>
      </div>

      <div ref="middle" class="middle">
        <div class="square-oe" @click="triangle5Click()">
          <div
            class="fantan-bet-lot-cell"
            :class="{ 'fantan-bet-lot-cell-active': win_oe === gameRow_oe[0] }"
          >
            <div class="fantan-bet-lot-title">
              <span>{{ $t("fantan.odd") }}</span>
            </div>

            <div class="fantan-bet-lot-bet-no" justify="center">
              {{ odd(o6) }}
            </div>
            <div
              v-if="stakeRecordSum(gameRow_oe[0]) != 0"
              class="fantan-bet-lot-stake-total"
            >
              {{ oddStake }}
            </div>
          </div>
        </div>

        <div class="square-oe" @click="triangle6Click()">
          <div
            class="fantan-bet-lot-cell"
            :class="{ 'fantan-bet-lot-cell-active': win_oe === gameRow_oe[1] }"
          >
            <div class="fantan-bet-lot-title">
              <span>{{ $t("fantan.even") }}</span>
            </div>

            <div class="fantan-bet-lot-bet-no" justify="center">
              {{ odd(o6) }}
            </div>
            <div
              v-if="stakeRecordSum(gameRow_oe[1]) != 0"
              class="fantan-bet-lot-stake-total"
            >
              {{ evenStake }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import FantanBetLot from "../../commons/FantanBetLot";
import FantanBetLotButton from "../widgets/FantanBetLotButton";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winNumbers",
    "gameData",
    "drawResult",
    "showDrawingAnimation",
  ],
  components: {
    Row,
    Col,
    Button,
    NewBetLot,
    FantanBetLot,
    FantanBetLotButton,
  },
  data() {
    return {
      o1: "o1",
      o6: "o6",
      gameRow_fan: ["fan1", "fan2", "fan3", "fan4"],
      gameRow_oe: ["odd", "even"],
      tri1Toggle: false,
      tri2Toggle: false,
      tri3Toggle: false,
      tri4Toggle: false,
      tri5Toggle: false,
      tri6Toggle: false,
      mouseClientY: null,
      mouseClientX: null,
      drawAnimation: false,

      ctx: null,
      ctx2: null,
      ctx3: null,
      ctx4: null,
    };
  },
  computed: {
    win_main() {
      for (let i = 0; i <= this.gameRow_fan.length; i++) {
        if (this.drawResult.fan == i) {
          i--; //to match gameRow_fan

          return this.gameRow_fan[i];
        }
      }
    },
    win_oe() {
      if (this.drawResult.oe === "1") {
        return "odd";
      } else if (this.drawResult.oe === "2") {
        return "even";
      }
    },
    evenStake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_oe[1]));
    },
    oddStake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_oe[0]));
    },
    fan1Stake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_fan[0]));
    },
    fan2Stake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_fan[1]));
    },
    fan3Stake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_fan[2]));
    },
    fan4Stake() {
      return display_numeric(this.stakeRecordSum(this.gameRow_fan[3]));
    },
  },
  methods: {
    displayNumeric(val) {
      return display_numeric(value);
    },
  },

  mounted() {
    let vm = this;

    this.canvasTopButton(this.gameData.prev.fan);
    this.canvasLeftButton(this.gameData.prev.fan);
    this.canvasRightButton(this.gameData.prev.fan);
    this.canvasBottomButton(this.gameData.prev.fan);

    //Tri 4 button
    this.$refs["canvas-area-left"].addEventListener("click", function (event) {
      let x = event.offsetX;
      let y = event.offsetY;

      let alpha;

      alpha = vm.ctx4.getImageData(x, y, 1, 1).data[3]; // [0]R [1]G [2]B [3]A

      // If pixel is transparent,
      // retrieve the element underneath and trigger it's click event
      if (alpha === 0) {
        vm.$refs["tri-left"].style.visibility = "hidden";

        document.elementFromPoint(event.clientX, event.clientY).click();

        vm.$refs["tri-left"].style.visibility = "visible";
      } else {
        vm.triangle4Click();
      }
    });

    //tri2 button
    this.$refs["canvas-area-right"].addEventListener("click", function (event) {
      let x = event.offsetX;
      let y = event.offsetY;

      let alpha;

      alpha = vm.ctx2.getImageData(x, y, 1, 1).data[3]; // [0]R [1]G [2]B [3]A

      // If pixel is transparent,
      // retrieve the element underneath and trigger it's click event
      if (alpha === 0) {
        vm.$refs["tri-right"].style.visibility = "hidden";

        document.elementFromPoint(event.clientX, event.clientY).click();

        vm.$refs["tri-right"].style.visibility = "visible";
      } else {
        vm.triangle2Click();
      }
    });
  },
  watch: {
    showDrawingAnimation(newVal) {
      this.drawAnimation = newVal;
    },
    drawResult(newVal, oldVal) {
      if (newVal && this.drawAnimation) {
        this.canvasTopButton(newVal.fan);
        this.canvasLeftButton(newVal.fan);
        this.canvasRightButton(newVal.fan);
        this.canvasBottomButton(newVal.fan);
      }
    },
  },
  methods: {
    canvasTopButton(result) {
      let canvasElement = this.$refs["canvas-area-top"];
      this.ctx = canvasElement.getContext("2d");
      let vm = this;

      let h1 = (vm.ctx.canvas.height = this.$refs["tri-top"].clientHeight);
      let w1 = (vm.ctx.canvas.width = this.$refs["tri-top"].clientWidth);
      var img1 = new Image();
      img1.src = "img/fantan/tri1.png";
      img1.onload = function (e) {
        vm.ctx.fillStyle = result == "3" ? "#6221F4" : "#FACC63";
        vm.ctx.fillRect(0, 0, w1, h1);
        vm.ctx.globalCompositeOperation = "destination-in";
        vm.ctx.drawImage(img1, 0, 0, w1, h1);
        vm.ctx.globalCompositeOperation = "source-over";
      };
    },
    canvasLeftButton(result) {
      let canvasElement4 = this.$refs["canvas-area-left"];
      this.ctx4 = canvasElement4.getContext("2d");
      let vm = this;

      let h4 = (vm.ctx4.canvas.height = this.$refs["tri-left"].clientHeight);
      let w4 = (vm.ctx4.canvas.width = this.$refs["tri-left"].clientWidth);
      var img4 = new Image();
      img4.src = "img/fantan/tri2.png";
      img4.onload = function (e) {
        vm.ctx4.fillStyle = result == "4" ? "#6221F4" : "#F5263E";
        vm.ctx4.fillRect(0, 0, w4, h4);
        vm.ctx4.globalCompositeOperation = "destination-in";
        vm.ctx4.drawImage(img4, 0, 0, w4, h4);
        vm.ctx.globalCompositeOperation = "source-over";
      };
    },
    canvasRightButton(result) {
      let canvasElement2 = this.$refs["canvas-area-right"];
      this.ctx2 = canvasElement2.getContext("2d");
      let vm = this;

      let h2 = (vm.ctx2.canvas.height = this.$refs["tri-right"].clientHeight);
      let w2 = (vm.ctx2.canvas.width = this.$refs["tri-right"].clientWidth);
      var img2 = new Image();
      img2.src = "img/fantan/tri3.png";
      img2.onload = function (e) {
        vm.ctx2.fillStyle = result == "2" ? "#6221F4" : "#16CC86";
        vm.ctx2.fillRect(0, 0, w2, h2);
        vm.ctx2.globalCompositeOperation = "destination-in";
        vm.ctx2.drawImage(img2, 0, 0, w2, h2);
      };
    },
    canvasBottomButton(result) {
      let canvasElement3 = this.$refs["canvas-area-buttom"];
      this.ctx3 = canvasElement3.getContext("2d");
      let vm = this;

      let h3 = (vm.ctx3.canvas.height = this.$refs["tri-bottom"].clientHeight);
      let w3 = (vm.ctx3.canvas.width = this.$refs["tri-bottom"].clientWidth);
      var img3 = new Image();
      img3.src = "img/fantan/tri4.png";
      img3.onload = function (e) {
        vm.ctx3.fillStyle = result == "1" ? "#6221F4" : "#C9C9C9";
        vm.ctx3.fillRect(0, 0, w3, h3);
        vm.ctx3.globalCompositeOperation = "destination-in";
        vm.ctx3.drawImage(img3, 0, 0, w3, h3);
      };
    },

    triangle1Click(e) {
      // console.log(this);
      let vm = this;
      if (this.tri1Toggle === false) {
        this.tri1Toggle = true;
      } else if (this.tri1Toggle === true) {
        this.tri1Toggle = false;
      }
      // console.log("tri1Toggle :" + this.tri1Toggle);
    },
    triangle2Click() {
      let vm = this;
      if (this.tri2Toggle === false) {
        this.tri2Toggle = true;
      } else if (this.tri2Toggle === true) {
        this.tri2Toggle = false;
      }
      // console.log("tri2Toggle :" + this.tri2Toggle);
    },
    triangle3Click() {
      let vm = this;
      if (this.tri3Toggle === false) {
        this.tri3Toggle = true;
      } else if (this.tri3Toggle === true) {
        this.tri3Toggle = false;
      }
      // console.log("tri3Toggle :" + this.tri3Toggle);

      // console.log("Yes this is 3");
    },
    triangle4Click() {
      let vm = this;
      if (this.tri4Toggle === false) {
        this.tri4Toggle = true;
      } else if (this.tri4Toggle === true) {
        this.tri4Toggle = false;
      }

      // console.log("tri4Toggle :" + this.tri4Toggle);
      // console.log("Yes this is 4");
    },

    triangle5Click() {
      let vm = this;
      if (this.tri5Toggle === false) {
        this.tri5Toggle = true;
      } else if (this.tri5Toggle === true) {
        this.tri5Toggle = false;
      }

      // console.log("tri5Toggle :" + this.tri5Toggle);
    },

    triangle6Click() {
      let vm = this;
      if (this.tri6Toggle === false) {
        this.tri6Toggle = true;
      } else if (this.tri6Toggle === true) {
        this.tri6Toggle = false;
      }

      // console.log("tri6Toggle :" + this.tri6Toggle);
    },
  },
};
</script>

<style lang="scss" scoped>
.invi-popper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: #f00;
  z-index: 100;
  display: none;
}

.invi-popper.show {
  display: block;
}

.tri-top-ph {
  width: 100%;
  height: 50%;
  position: absolute;
  top: 0px;
  left: 0px;
  // background: yellow;
}

.tri-right-ph {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.tri-bottom-ph {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0px;
}

.tri-left-ph {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
  cursor: pointer;
}

.middle-ph {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  border-radius: 10px;
  z-index: -1;
  // border: 1px solid #111113;



  

}

.middle-ph .square-o,
.middle-ph .square-e {
  width: 50%;
  background: linear-gradient(#474b4c, #111113);
  height: 100%;
  // border: 1px solid #111113;
  // border: 1px solid red;

  box-sizing: border-box;
  border-radius: 10px;
  text-align: center;
  color: #daa520;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #111113;

}

.triangle-area {
  z-index: 1;
}

.fantan-fan-betlot {
  position: absolute;
  // top: 0;
  top: 15px;

  text-align: center;
  left: 50%;
  transform: translateX(-50%);
}

.fantan-fan2-betlot {
  // color: black;
  position: absolute;
  // text-align: center;
  font-weight: bold;
  // right: 0;
  right:  20px;
  // top: 50%;
  top: 60%;

  transform: translateY(-50%);
}

.fantan-fan3-betlot {
  position: absolute;
  text-align: center;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.fantan-fan4-betlot {
  position: absolute;
  text-align: center;
  left: 20px;
  // left: 0;

  // top: 50%;
  top: 60%;

  transform: translateY(-50%);
}

.fantan-mainbet {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.triangle-area {
  width: 100%;
  height: 134px;
  // padding: 5px;
  background-color: #f3e8d4;
  border-radius: 10px;
}

.canvas-wrapper-top {
  width: 100%;
  height: 100%;
  position: relative;
}

.canvas-wrapper-bottom {
  width: 100%;
  height: 100%;
  position: relative;
}

.canvas-wrapper-left {
  width: 100%;
  height: 100%;
  position: relative;
}

.canvas-wrapper-right {
  width: 100%;
  height: 100%;
  position: relative;
}

.canvas-area-top {
  width: 100%;
  height: 100%;

  border-radius: 10px;
}
.canvas-area-right {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.canvas-area-buttom {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.canvas-area-left {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.canvas2 {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 5px;
  left: 0px;
  top: 0px;
}
.square {
  width: 100%;
  height: 38%;
  position: absolute;
  align-items: baseline;
  top: 0;
  bottom: 0;
  left: 5px;
  right: 0;
  margin: auto;
  padding: 0 50px;
  box-sizing: border-box;
}

.square-oe {
  width: 50%;
  background: linear-gradient(#474b4c, #111113);
  height: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  text-align: center;
  // border: 1px solid #111113;
  // border: 1px solid blue;

  color: #daa520;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #111113;

}

.square-oe .fantan-bet-lot-cell {
  height: 100%;
  padding-top: 15px;
  border-radius: 10px;
  // border: 1px solid red;
  

}

.square-oe .fantan-bet-lot-cell.fantan-bet-lot-cell-active {
  background: #6221f4;
  color: #fff;
  // border: 1px solid #111113;

}

.triangle1 {
  width: 97%;
  height: 49px;
  overflow: hidden;
  position: absolute;
}
.triangle1 a {
  width: 100%;
  height: 100%;
  background: yellow;
  position: absolute;
}
.triangle1-betlot {
  width: 97%;
  height: 49px;
  position: absolute;
}
.triangle2 {
  width: 50px;
  height: 140px;
  position: absolute;
  right: 5px;
  overflow: hidden;
}
.triangle2 a {
  width: 207%;
  height: 71%;
  background: forestgreen;
  transform-origin: 0 100%;
  transform: rotate(45deg);
  position: absolute;
  right: -65%;
  top: -21%;
}
.triangle3 {
  width: 97%;
  height: 49px;
  position: absolute;
  bottom: 5px;
}
.triangle3 a {
  width: 100%;
  height: 100%;
  background: white;

  position: absolute;
}
.triangle4 {
  width: 50px;
  height: 140px;
  overflow: hidden;
  position: absolute;
}
.triangle4 a {
  width: 203%;
  height: 71%;
  background: red;
  transform-origin: 0 100%;
  transform: rotate(45deg);
  position: absolute;
  left: -143%;
  top: -22%;
}
.middle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: #000000;
  border-radius: 10px;
}

.triangle1 a:hover,
.triangle2 a:hover,
.triangle3 a:hover,
.triangle4 a:hover {
  background: orange;
}

.title {
  color: black;
  position: absolute;
  text-align: center;
  font-weight: bold;
}

.triangle-title-1 {
  top: -0px;
  width: 100%;
}

.triangle-title-2 {
  top: 7px;
  right: -42px;
}

.triangle-title-3 {
  bottom: -12px;
  width: 100%;
}

.triangle-title-4 {
  top: 7px;
  left: -38px;
}

.fantan-mainbet-title {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #1c3a67;
  font-weight: bold;
  color: white;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
}
.fantan-mainbet-container {
  display: flex;
  padding: 5px 5px 0;
}
.fantan-mainbet-divider {
  height: 1px;
}
.fantan-mainbet-betlot {
  flex: auto;
  background: #ffffff;
}

.fantan-mainbet-betlot:hover {
  background: #f5eeb8;
  cursor: pointer;
}

.fantan-mainbet-betlot:first-of-type {
  margin-left: unset;
  border-radius: 5px 0 0 5px;
}

.fantan-mainbet-betlot:last-of-type {
  margin-right: unset;
  border-radius: 0 5px 5px 0;
}

.tri-top {
  width: 100%;
  height: 50%;
  position: absolute;
  top: 0px;
  left: 0px;
}
.tri1 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
.tri4 {
  top: 0px;
  left: 0px;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.tri-left {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
  cursor: pointer;
}
.tri2 {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  padding: 5px;
}
.tri-right {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.tri3 {
  height: 100%;
  width: 100%;
}
.tri-bottom {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0px;
}

.open-result .fantan-bet-lot-cell-active {
  background: linear-gradient(to right, #1a6dbc, #52b2ff);
  color: #fff;
}

.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-title,
.open-result .fantan-bet-lot-cell-active .fantan-bet-lot-bet-no {
  color: #fff;
  opacity: 1;
}

.fantan-bet-lot-cell {
  width: 100%;
  text-align: center;
  position: relative;
  pointer-events: none;
}

.tri-top .fantan-bet-lot-cell,
.tri-bottom .fantan-bet-lot-cell {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  vertical-align: middle;
  align-items: center;
}

.tri-top .fantan-bet-lot-cell {
  top: -100%;
}

.tri-bottom .fantan-bet-lot-cell {
  bottom: 50%;
}

.tri-left .fantan-bet-lot-cell {
  width: 50%;
  top: -50%;
  transform: translateY(-50%);
}

.tri-right .fantan-bet-lot-cell {
  width: 50%;
  top: -50%;
  transform: translateY(-50%);
  float: right;
}

.fantan-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.fantan-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.fantan-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.fantan-bet-lot-title {
  font-family: "Oswald";
  text-align: center;
  font-weight: bold;
  // text-transform: uppercase;
  font-size: 15px;
  color: #ffffff;
  text-shadow: 0px 1px 0px #00000029;
  padding: 0 9px;
}

.fantan-bet-lot-title .g-title {
  font-size: 22px;
  margin-left: 2px;
}

.tri-left .fantan-bet-lot-title,
.tri-right .fantan-bet-lot-title {
  padding: 0;
}

.middle .fantan-bet-lot-title {
  font-family: "Oswald";
  text-align: center;
  font-weight: bold;
  // text-transform: uppercase;
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 1px 0px #00000029;
  padding: 0;
}

.fantan-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.fantan-bet-lot-bet-no {
  font-family: "Oswald";
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0px 1px 0px #00000029;
}

.tri-left .fantan-bet-lot-bet-no,
.tri-right .fantan-bet-lot-bet-no {
  padding: 0 10px;
}

.middle .fantan-bet-lot-bet-no {
  font-family: "Oswald";
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  padding: 0;
  text-shadow: 0px 1px 0px #00000029;
}

.fantan-bet-lot-bet-no.small {
  height: unset;
}

.tri-top .fantan-bet-lot-bet-no,
.tri-bottom .fantan-bet-lot-bet-no {
  margin-top: 9px;
}
</style>

<style lang="scss">
// .fantan-bet-lot-cell.fantan-bet-lot-cell-active .fantan-bet-lot-title {
//   color: #a57dff;
// }

.fantan-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 10px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-radius: 0 8px;
  max-height: 16px;
  line-height: 16px;
}

.tri-left .fantan-bet-lot-stake-total,
.tri-right .fantan-bet-lot-stake-total {
  // top: -12px;
  top: -10px;
  border-radius: 5px;
}

// .middle .fantan-bet-lot-stake-total {
//   top: 0;
//   right: 0;
// }
</style>
